import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { SettingsContext } from "../../../contexts";
import { DataHelper } from "../../../helpers";
import { Money } from "../../../components/formatters";
import { getFileUrl } from "../../../core/config/api";
import { getBaseCurrency } from "../../../core/currency";

export function LookbookProductInfo({
  listing,
  product,
  isNetwork = false,
  imageOverlay = null,
}) {
  const { settings } = useContext(SettingsContext);
  // Same onError-state pattern as order/components/ItemProduct/ProductImage.jsx:
  // `/assets/placeholder-watch.png` doesn't exist in public/, so the old
  // fallback 404'd to index.html. No image / a 404 now renders no <img> at
  // all rather than a broken icon.
  const [imageBroken, setImageBroken] = useState(false);
  const imageId = product?.images?.[0]?.id;
  const imageUrl = imageId ? getFileUrl(imageId) : null;
  const brand = product?.brand?.name || "";
  const model = product?.model?.name || "";
  const availability = !isNetwork
    ? DataHelper.availability.find((a) => a.id === listing.availability)?.name
    : null;

  return (
    <div className="lb-product-info">
      <div className="lb-product-info__image-wrap">
        <Link
          to={`/product/${listing.id}?${settings.iframeQueryParams}`}
          className="lb-product-info__image-link"
          onClick={(e) => e.stopPropagation()}
        >
          {imageUrl && !imageBroken && (
            <img
              src={imageUrl}
              alt={`${brand} ${model}`}
              className="lb-product-info__image"
              onError={() => setImageBroken(true)}
            />
          )}
        </Link>
        {imageOverlay}
      </div>

      <div className="lb-product-info__details">
        <Link
          to={`/product/${listing.id}?${settings.iframeQueryParams}`}
          className="lb-product-info__link"
          onClick={(e) => e.stopPropagation()}
        >
          {brand && <span className="lb-product-info__brand">{brand}</span>}
          {model && <span className="lb-product-info__model">{model}</span>}
          <Money
            currency={listing.currency ?? getBaseCurrency()}
            amount={listing.price}
            zero="Price on Request"
            className="lb-product-info__price"
          />
          {product?.reference_number && (
            <span className="lb-product-info__ref">{product.reference_number}</span>
          )}
          {listing.year && (
            <span className="lb-product-info__year">{listing.year}</span>
          )}
          {availability && (
            <span className="lb-product-info__status">{availability}</span>
          )}
        </Link>
      </div>
    </div>
  );
}
